import { useLocalSearchParams } from 'expo-router'

import { IntentionFormScreen } from '@/src/features/intention/ui/screens/IntentionFormScreen'

export default function IntentionFormScreenWrapper() {
  const { theme } = useLocalSearchParams<{ theme: string }>()
  return <IntentionFormScreen theme={theme} />
}
